<template>
  <v-container class="ma-2 ma-sm-12" fluid>
    <v-row class="my-4" justify="start">
      <v-col cols="12" md="3"><div class="text-h5 font-weight-black _light_grey--text">{{ $t('accountingInfo') }}</div></v-col>
      <!-- <v-col cols="12" md="3">
        <v-select
          :prefix="`${$t('year')}: `"
          :items="yearList"
          v-model="year"
          outlined
          hide-details
          class="_light_grey customStyle"
          :label="$t('year')"
        ></v-select>
      </v-col>
      <v-col cols="12" md="3">
        <v-select
          :prefix="`${$t('month')}: `"
          :items="monthList"
          v-model="month"
          outlined
          hide-details
          class="_light_grey customStyle"
          :label="$t('month')"
        ></v-select>
      </v-col> -->
      <v-col cols="12" offset-md="6" md="3" align="end">
        <v-chip
          v-if="this.costLimit > 0"
          label
          color="_blue"
          text-color="_light_grey"
          large
          close
          close-icon="mdi-delete-forever"
          @click:close="cancelDialog = true"
        >
          {{ $t('alarmLimit') + '：' + costLimit }}
        </v-chip>
        <v-text-field
          v-else
          ref="alarmLimit"
          v-model="alarmLimit"
          :label="$t('alarmLimit')"
          background-color="_light_grey"
          filled
          append-icon="mdi-content-save"
          :rules="[() => (alarmLimit > 0 && alarmLimit <= 2100000000) || $t('errNumber')]"
          @click:append="submitDialog = true"
        ></v-text-field>
      </v-col>
    </v-row>
    <iframe :src="dashboardUrl" title="Dashboard" width="100%" height="800" frameborder="0"></iframe>
    <Dialog :isShow="submitDialog" title="submit" msg="confirmMsg" verbMsg="submit" @confirm="setCostLimit()" @cancel="submitDialog = false" />
    <Dialog :isShow="cancelDialog" title="cancel" msg="confirmMsg" verbMsg="cancel" @confirm="delCostLimit()" @cancel="cancelDialog = false" />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import File from '@/api/file';
import User from '../store/user';
import Dialog from '../components/Dialog.vue';

export default {
  name: 'Bill',
  data: () => ({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    startYear: 2021,
    url: '',
    costLimit: 0,
    alarmLimit: '',
    submitDialog: false,
    cancelDialog: false,
    encryptEmail: '',
  }),
  components: { Dialog },
  mounted() {
    this.getCostLimit();
    this.encrypt();
  },
  computed: {
    ...mapState('authenticate', ['isSignIn', 'userAttribute']),
    account() {
      if (!this.isSignIn) return '';
      return this.userAttribute.email;
    },
    yearList() {
      const num = new Date().getFullYear() - this.startYear;
      if (num === 0) {
        return [this.startYear];
      }
      return Array(num + 1)
        .fill()
        .map((value, index) => index + this.startYear);
    },
    monthList() {
      return Array(12)
        .fill()
        .map((value, index) => index + 1);
    },
    dashboardUrl() {
      // const url = `https://cashflow.imacloud.com.tw/Pay/List?account=${this.encryptEmail}`;
      let url = 'https://manager.imacloud.com.tw:3000/d/XEOLIz9Mz/smp-statistics-user?orgId=1&refresh=10s';
      url = `${url}&var-userid=${this.account}&var-year=${this.year}&var-month=${this.month}&kiosk`;
      return url;// `https://cashflow.imacloud.com.tw/Pay/List?account=${encodeURIComponent(this.encryptEmail)}`;
    },
  },
  methods: {
    async encrypt() {
      const value = await User.encrypt({ text: this.account });
      this.encryptEmail = value.data;
    },
    setCostLimit() {
      this.submitDialog = false;
      if (!this.$refs.alarmLimit.validate()) {
        this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errNumber')] });
        return;
      }
      const data = { userId: this.account, alarmPrice: this.alarmLimit };
      File.api('https://manager.imacloud.com.tw:8443/dw/priceIntegration/alarm/info', 'POST', data).then(() => {
        this.$store.commit('notify/set', { type: 'success', msg: [this.$t('submit'), ' ', this.$t('success')] });
        this.getCostLimit();
        this.alarmLimit = '';
      });
    },
    getCostLimit() {
      File.api(`https://manager.imacloud.com.tw:8443/dw/priceIntegration/alarm/info/${this.account}`, 'GET').then((result) => {
        if (!result.data) this.costLimit = 0;
        else {
          this.costLimit = result.data.alarmPrice;
        }
      });
    },
    delCostLimit() {
      this.cancelDialog = false;
      File.api(`https://manager.imacloud.com.tw:8443/dw/priceIntegration/alarm/info/${this.account}`, 'DELETE').then(() => {
        this.$store.commit('notify/set', { type: 'success', msg: [this.$t('cancel'), ' ', this.$t('success')] });
        this.getCostLimit();
      });
    },
  },
};
</script>
